// helpers.ts — Pure utility functions for D202 (繳庫單) form

/** Convert ISO date string to HTML date input value (YYYY-MM-DD) */
export const dateToInput = (v: string | null | undefined): string => {
  if (!v) return '';
  return v.substring(0, 10);
};

/** Convert HTML date input value to ISO date string */
export const inputToDate = (v: string): string | null => {
  if (!v) return null;
  return v + 'T00:00:00Z';
};

/** Format number with locale grouping, max 2 decimals */
export const fmt = (v: number | null | undefined): string => {
  if (v == null || v === 0) return '0';
  return v.toLocaleString('en-US', { maximumFractionDigits: 2 });
};

/** Derive the approval status badge for a record */
export const getStatusBadge = (record: { fd120_80?: string; fd120_13?: number } | null): { text: string; cls: string } | null => {
  if (!record) return null;
  const s80 = (record.fd120_80 || '').trim();
  if (s80 === 'P') return { text: '已核准', cls: 'badge-success' };
  if (s80 === 'D' || s80 === 'S') return { text: '送審中', cls: 'badge-warning' };
  if (s80 === 'N' || s80 === '') return { text: '草稿', cls: 'badge-default' };
  return { text: `未知狀態（${s80}）`, cls: 'badge-warning' };
};

/** Category label: 1=正常, 2=異常 */
export const getCategoryLabel = (v: number | undefined): string => {
  if (v === 1) return '正常';
  if (v === 2) return '異常';
  return '';
};

/** Material type label: 1=原料, 2=半成品, 3=成品 */
export const getMaterialTypeLabel = (v: number | undefined): string => {
  if (v === 1) return '原料';
  if (v === 2) return '半成品';
  if (v === 3) return '成品';
  return '';
};

/** Fields that are always readonly in any mode */
const ALWAYS_READONLY = new Set([
  'fd120_01', 'fd120_16', 'fd120_19', 'fd120_20', 'fd120_201',
  'fd120_32', 'fd120_91',
]);

/** Determine if a field should be disabled */
export const isFieldDisabledFn = (key: string, isEditing: boolean, _mode: string): boolean => {
  if (!isEditing) return true;
  if (ALWAYS_READONLY.has(key)) return true;
  return false;
};
